import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { merge, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { fuseAnimations } from '@fuse/animations';

import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';
import { HttpClient } from '@angular/common/http';
import { DATOS_API } from 'app/auth/auth.datos';
// INTERFACES DE ENVIO Y RESPUESTA AL BACKEND
import * as backInter from 'app/auth/auth-data.model';
import { lang_navigation } from 'app/idiomas/i18n/navigation/navigation.lang';
import { institutos } from '../../../app/idiomas/i18n/perfiles/catalogos/en';
import { LogActualizacionesService } from "app/main/pagina/tools/log-actualizaciones/log-actualizaciones.service";

const moment = require('moment');

@Component({
    selector       : 'fuse-navigation',
    templateUrl    : './navigation.component.html',
    styleUrls      : ['./navigation.component.scss'],
    encapsulation  : ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations   : fuseAnimations
})
export class FuseNavigationComponent implements OnInit
{
    @Input()
    layout = 'vertical';
    @Input()
    navigation: any;
    // Private
    private _unsubscribeAll: Subject<any>;
    //variables de autenticacion
    datosUsu: backInter.infoUsuario;
    // datosProd: backInter.infoProductos;
    datosProd: any;
    idInstituto: string;
    listaProdsCertificar: any[] = [];
    listaProdsMedir: any[] = [];
    listaProdsPulse: any[] = [];
    listaProdsFocus: any[] = [];
    listaProdsLeaderGo: any[] = [];
    listaProdsActionGo: any[] = [];
    listaProdsCerAmco: any[] = [];
    listaProdsCultureTR: any[] = [];
    listaProdsCultureBriefCAYC: any[] = [];
    listaProdsCultureICCA: any[] = [];
    listaProdsCultureGral: any[] = [];
    listaProdsCultureOzel: any[] = [];
    listaProdsCultureMexico: any[] = [];
    infoNiveles = [
      {id: 1, infoProductos: true, nombre: 'Empresa'},
      {id: 2, infoProductos: false, nombre: 'Administrador'},
      {id: 3, infoProductos: false, nombre: 'ITBM'},
      {id: 4, infoProductos: true, nombre: 'Resultados'},
      {id: 5, infoProductos: true, nombre: 'Resultados segmentados'},
      {id: 8, infoProductos: true, nombre: 'Producto Culture Audit'},
      {id: 9, infoProductos: false, nombre: 'Resultados 5.0'},
      {id: 10, infoProductos: true, nombre:'Compañia RH'},
      {id: 11, infoProductos: false, nombre: 'Izzi'},
      {id: 12, infoProductos: false, nombre: 'ActionGo'},
      {id: 13, infoProductos: false, nombre: 'Resultados segmentados y ActionGo'},
      {id: 14, infoProductos: false, nombre: 'ActionGo Líder'},
      {id: 15, infoProductos: true, nombre: 'ActionGo User'},
      {id: 16, infoProductos: true, nombre: 'LeaderGo User'},
      {id: 19, infoProductos: false, nombre: 'Resultados 2.0'},
    ];
    statusProductosPadre = {  //contiene los productos que tienen subproductos, para activar el boton del menu si es necesario
      certificar: false,
      medir: false,
      pulse: false,
      focus: false,
      cerAmco: false,
    }
    idsProductosCert3Falsos = [
      {id:41, activo: false}, // medir 3.0
      {id:42, activo: false}, // pulse check 3.0
      {id:43, activo: false}, // pulse check 3.0
      {id:53, activo: false}, // Leader Go 3.0
      {id:54, activo: false}, // Action GO 3.0
      {id:56, activo: false}, // Certify Amco
      {id:57, activo: false}, // Certify Trabajo digno
      {id:58, activo: false}, // Certify Primer Empleo
      {id:60, activo: false}, // Resultados V2 HK
    ];

    idsProductosCultureAuditMx = [
      {tipo: 4, activo: false}, // medir 3.0
      {tipo: 5, activo: false}, // pulse check 3.0
      {tipo: 6, activo: false}, // pulse check 3.0
      {tipo: 7, activo: false}, // Leader Go 3.0
      {tipo: 10, activo: false}, // Culture Audit 10
      {tipo: 11, activo: false}, // Culture Audit 11
      {tipo: 12, activo: false}, // Culture Audit 12
      {tipo: 14, activo: false}, // Culture Audit 14
      {tipo: 15, activo: false}, // Culture Audit 15
      {tipo: 22, activo: false}, // Culture Audit 22
      {tipo: 23, activo: false}, // Culture Audit 23
      {tipo: 24, activo: false}, // Culture Audit 24
      {tipo: 25, activo: false}, // Culture Audit 25
      {tipo: 26, activo: false}, // Culture Audit 26
      {tipo: 27, activo: false}, // Culture Audit 27
      {tipo: 28, activo: false}, // Culture Audit 28
      {tipo: 30, activo: false}, // Culture Audit 30
      {tipo: 31, activo: false}, // Culture Audit 30
      {tipo: 32, activo: false}, // Culture Audit 30
    ];

    parcheDesconocido1: boolean;  //no se ke pex con esto, mejor lo dejo aunque no se para que sea
    versionActual: string;
    brokerConfig: any;
    datosUsuLogin:any;

    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _fuseNavigationService: FuseNavigationService,
        private _translateService: TranslateService,
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        /// SERVICIO DE AUTENTICACION
        public authService: AuthService,
        private http:HttpClient,
        private las: LogActualizacionesService
    )
    {
        // Set the private defaults
      this._unsubscribeAll = new Subject();
      lang_navigation.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
      });


    }

    ngOnInit(): void
    {
      // Load the navigation either from the input or from the service
      this.datosProd=null;
      this.navigation = this.navigation || this._fuseNavigationService.getCurrentNavigation();
      console.log("Navigation:",this.navigation);
      this.getInfoUsuario();
      this.getUltimaVersion();
      this.getBrokerConfig();
    }

    getBrokerConfig(){
      this._fuseNavigationService.getBrokerConfig().subscribe((respuesta:any) => {
        console.log("getBrokerConfig:",respuesta);
        if(respuesta.success){
          this.brokerConfig = respuesta.catBrokerConfiguration;
        }
      })
    }

    resetVariables(){
      this.datosUsu = null;
      this.datosProd = null;
      //reinicia los status de los productos padre
      for(var k in this.statusProductosPadre){
        this.statusProductosPadre[k] = false;
      }
    }
    getInfoUsuario(){
      this.resetVariables();
      if(this.authService.getIsAuth()){
        let datosUsu = this.authService.getInfoUsuario();
        let datos_idusuario = this.authService.getIdUsuario();

        console.log('datosUsu.::::::::::::::::::::',datosUsu);
        this.datosUsuLogin=datosUsu;
        localStorage.setItem('user_padre',''+datosUsu.user);
        if(datosUsu.institutoId){
          localStorage.setItem('instituto_id',''+datosUsu.institutoId);
        } else{
          localStorage.setItem('instituto_id',''+this.authService.getInstituto());
        }
        localStorage.setItem('levelUser_tmp', ''+datosUsu.level);
        if(datosUsu.empresaId == "0"){
          localStorage.setItem('nameCity','TOOLBAR.CITIES.0')
        }
        // this.idInstituto = this.authService.getInstituto();
        // let prro = this.authService.getInstituto();
        // console.log("prro:",localStorage.getItem('instituto_id'));

        this.idInstituto = localStorage.getItem('instituto_id');
        // localStorage.getItem('instituto_id') == undefined? this.idInstituto = this.authService.getInstituto() : this.idInstituto = localStorage.getItem('instituto_id');
        // localStorage.setItem('instituto_id',this.idInstituto);
        if(datosUsu.empresaId == '5efba3b70890b84b5d8b5c83'){ // Se va a borrar despues de validar el modulo
          this.parcheDesconocido1=true;
        }
        this.getInfoProductos(datosUsu);
      }
    }

    async getInfoProductos(datosUsu: backInter.infoUsuario){

      this.reiniciaProductosActivos();
      if(localStorage.getItem('lastVersion') == undefined){
        const getVersFinal = await this.getUltimaVersion();
      } else{
        this.versionActual = localStorage.getItem('lastVersion');
      }
      if(this.infoNiveles.findIndex(item => item.id == datosUsu.level && item.infoProductos == true) != -1){
        if(datosUsu.institutoId){
          localStorage.setItem('nameCity','TOOLBAR.CITIES.'+datosUsu.institutoId.toString());
        }
        //GET INFO EMPRESA
        console.log("datosUsu",datosUsu);

        const datosEmpresa:any = await this.http.get(DATOS_API.url + DATOS_API.endpoints.empresas + datosUsu.empresaId).toPromise();
        console.log('fileServer_v2',datosEmpresa);

        if(datosEmpresa.fileServer_v2 == true){ //si la bandera de mostrar el file server anterior es true, se muestra la landing de cloud
          if (datosUsu.level!=15) {
            this.activaProductoEspecifico("cloud"); //se activa aquí y posteriormente se desactiva en la funcion de valida productos
            this.activaProductoEspecifico("file-server");
          }
        }
        //GET PRODUCTOS
        this.datosProd = await this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + datosUsu.empresaId).toPromise();
        console.log("getProductosNavigation:",this.datosProd);
        // Validación para ver si tiene NORMA35 (Para filemanager)
        if(this.datosProd.productosNorma35){
          if(this.datosProd.productosNorma35.length >0){
            localStorage.setItem('tipo35_tmp', ''+this.datosProd.productosNorma35[0].tipo);
            localStorage.setItem('producto35', '1'); // tiene norma
          }else{
            localStorage.setItem('producto35', '2'); // tiene norma
          }
        }else{
          localStorage.setItem('producto35', '2'); // tiene norma
        }
        this.filtraProductosMedir();
        this.validarProductos(datosUsu.level);
        this.validarHerramientas(datosUsu.level);
        this.validarResultados(datosUsu.level);
        this.creaNavLinks();
      }
      else{
        if(datosUsu.empresaPadre){ // Validación para los centros de trabajo hijo en norma
          localStorage.setItem('idPadre_temporal', ''+datosUsu.empresaPadre);
        }
        this.validarProductos(datosUsu.level);
        this.validarHerramientas(datosUsu.level);
        this.validarResultados(datosUsu.level);
        this.creaNavLinks();
      }
    }

    async getUltimaVersion(){
      let getChangelog:any = await this.las.getChangelog().toPromise();
      if(getChangelog.success){
        getChangelog.versions.sort( (a,b) => {
          if(moment(a.createdAt).isBefore(moment(b.createdAt))){ return 1; } else{ return -1; }
        });
        console.log("getChangelog.versions:",getChangelog.versions);

        this.versionActual = getChangelog.versions[0].version;
        localStorage.setItem('lastVersion', this.versionActual);
        console.log("this.versionActual FISTR:",this.versionActual);
      }
    }

    //oculta todos los productos y herramientas, se volverán a mostrar de acuerdo a las validaciones de las funciones posteriores
    reiniciaProductosActivos(){
      this.navigation.forEach(categoria => {
        categoria.hidden = true;
        categoria.children.forEach(producto => {
          producto.hidden = true;
          if(producto.type == "collapsable"){
            producto.children.forEach(subproducto => {
              subproducto.hidden = true;
            });
          }
        });
      });
      console.log("navigation despues de reinciar:",this.navigation);

    }

    activaProductoEspecifico(id:string, recursivo?:boolean, arreglo?:any, nuevoTexto?:string, badge?:string){
        // console.log('id',id);
        // console.log('recursivo',recursivo);
        // console.log('arreglo',arreglo);
        // console.log('nuevoTexto',nuevoTexto);

      let encontrado = false;
      if(!recursivo){
        this.navigation.forEach(categoria => {
          if(categoria.type == 'group'){
            if(id == categoria.id){
              nuevoTexto != undefined ? categoria.translate = nuevoTexto : categoria.hidden = !categoria.hidden;
              encontrado = true;
            }
            if(categoria.children.length > 0 && !encontrado){
              this.activaProductoEspecifico(id, true, categoria.children, nuevoTexto, badge);
            }
          }
        });
      }
      else if(recursivo){
        arreglo.forEach(producto => {
          if(producto.id == id){
            // producto.hidden = !producto.hidden;
            nuevoTexto != undefined ? producto.translate = nuevoTexto : producto.hidden = !producto.hidden;
            badge != undefined ? producto.badge.title = badge : false;
            encontrado = true;
          }
          if(!encontrado){
            if(producto.type == "collapsable"){
              this.activaProductoEspecifico(id, true, producto.children, nuevoTexto, badge);
            }
          }
        });
      }
    }

    validarProductos(nivel:number){
      console.log('nivel',nivel);

      this.activaProductoEspecifico("applications");  //activa la seccion de productos antes de evaluar cada nivel
      switch (nivel) {
        case 1: //nivel empresa
          localStorage.setItem('Leveuser', '1');
          //activa los botones de acceso a cada certificar
          if(this.statusProductosPadre.certificar){
            this.activaProductoEspecifico("certificar");
            if (this.idInstituto=='19') {
              this.activaProductoEspecifico("certificar",null,null, 'NAV.medir_INNO.TITULO');
            }
          }
          if(this.listaProdsCertificar[0].lista.length > 0) this.activaProductoEspecifico("certify_0");
          if(this.listaProdsCertificar[1].lista.length > 0) this.activaProductoEspecifico("certify_1");
          if(this.listaProdsCertificar[2].lista.length > 0) this.activaProductoEspecifico("certify_2");
          if(this.listaProdsCertificar[3].lista.length > 0){
            this.activaProductoEspecifico("certify_3");
            if (this.idInstituto=="19") {
            this.activaProductoEspecifico("certify_3",null,null, 'NAV.medir_INNO.TITULO');
            }
          }


          if(this.listaProdsCertificar[4].lista.length > 0) this.activaProductoEspecifico("certify_4");
          if(this.listaProdsCertificar[5].lista.length > 0) this.activaProductoEspecifico("certify_6");
          //activa los botones de acceso a cada medir
          if(this.statusProductosPadre.medir) this.activaProductoEspecifico("medir");
          if(this.listaProdsMedir[0].lista.length > 0) this.activaProductoEspecifico("medir_0");
          if(this.listaProdsMedir[1].lista.length > 0) this.activaProductoEspecifico("medir_1");
          if(this.listaProdsMedir[2].lista.length > 0) this.activaProductoEspecifico("medir_2");
          if(this.listaProdsMedir[3].lista.length > 0) this.activaProductoEspecifico("medir_3");
          if(this.listaProdsMedir[4].lista.length > 0) this.activaProductoEspecifico("medir_4");
          if(this.listaProdsMedir[5].lista.length > 0) this.activaProductoEspecifico("medir_5");
          if(this.listaProdsMedir[6].lista.length > 0) this.activaProductoEspecifico("medir_6");
          if(this.listaProdsMedir[7].lista.length > 0) this.activaProductoEspecifico("medir_7");
          //activa los botones de acceso a cada pulse
          if(this.statusProductosPadre.pulse) this.activaProductoEspecifico("pulse");
          if(this.listaProdsPulse[0].lista.length > 0) this.activaProductoEspecifico("pulse_0");
          if(this.listaProdsPulse[1].lista.length > 0) this.activaProductoEspecifico("pulse_1");
          //activa los botones de acceso a cada focus
          // if(this.statusProductosPadre.focus) this.activaProductoEspecifico("focus");
          // if(this.listaProdsFocus[0].lista.length > 0) this.activaProductoEspecifico("focus");
          if(this.listaProdsFocus[1].lista.length > 0) this.activaProductoEspecifico("focus1");
          if(this.listaProdsLeaderGo[0].lista.length > 0)this.activaProductoEspecifico("leaderGOAdmin");
          if(this.listaProdsActionGo[0].lista.length > 0) this.activaProductoEspecifico("actionGoAdmin");
          // if(this.listaProdsActionGo[0].lista.length > 0) this.activaProductoEspecifico("actionGO");
          //activa los botones de acceso a cada culture audit
          if(this.datosProd.productosCultureAudit.length > 0) this.activaProductoEspecifico("Culture");
          // if(this.datosProd.productosCultureAuditV2.length > 0) this.activaProductoEspecifico("Culture_v2");
          if(this.datosProd.productosCultureAuditTR.length > 0) this.activaProductoEspecifico("Culture_tra");
          //activa los botones de acceso a los demas productos que no tienen subproductos
          // if(this.datosProd.productosFocusArea.length > 0) this.activaProductoEspecifico("focus");
          if(this.datosProd.productosNorma35.length > 0){
            this.activaProductoEspecifico("certificarN35");
            let norma35:any[]=[];
            let norma35bett:any[]=[];
            let norma35plat:any[]=[];
            let norma35V3:any[]=[];
          this.datosProd.productosNorma35.forEach(norma => {
            switch (norma.tipo) {
              case 1:
              norma35.push(norma);
              break;
              case 2:
              norma35bett.push(norma);
              break;
              case 3:
              norma35plat.push(norma);
              break;
              case 4:
              norma35V3.push(norma);
              break;

              default:
                break;
            }
          });

          if (norma35.length>0) {
            this.activaProductoEspecifico("certificarN35_No");
          }
          if (norma35bett.length>0) {
            this.activaProductoEspecifico("certificarN35_Bet");
          }
          if (norma35plat.length>0) {
            this.activaProductoEspecifico("certificarN35_Pla");
          }
          if (norma35V3.length>0) {
            this.activaProductoEspecifico("certificarN35V3");
          }

          }

          if(this.statusProductosPadre.cerAmco) this.activaProductoEspecifico("certiAmco");
          if(this.listaProdsCerAmco[0].lista.length > 0) this.activaProductoEspecifico("amco");
          if(this.listaProdsCerAmco[1].lista.length > 0) this.activaProductoEspecifico("traba_digno");
          if(this.listaProdsCerAmco[2].lista.length > 0) this.activaProductoEspecifico("prime_emple");
          if (this.datosUsuLogin.leader_go)this.activaProductoEspecifico("leaderGO");
          if (this.datosUsuLogin.action_go)this.activaProductoEspecifico("actionGO");
          if(this.listaProdsCultureGral.length > 0){
            this.activaProductoEspecifico("Culture_v2");
            let subProductos = [false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false];
            // casos de uso para culture audit
            console.log('this.idInstituto',this.idInstituto);

            switch (this.idInstituto) {
              case '1': // instituto MX
                localStorage.setItem('CultureMexico','true');
                localStorage.setItem('CultureTurquia','Falso');
                if (this.listaProdsCultureMexico.length>0) {
                  this.activaProductoEspecifico("Culture_v2");  //oculta este producto
                  this.activaProductoEspecifico("Culture_MX");  //y activa el del menu

                this.listaProdsCultureGral.forEach(producto => {
                  // console.log("productoCA:",producto);

                  if(!producto.tipo && !subProductos[0]){
                    subProductos[0] = true;
                    this.activaProductoEspecifico("Culture_MX1");
                  }else if(producto.tipo == 4 && !subProductos[1]){
                    subProductos[1] = true;
                    this.activaProductoEspecifico("Culture_MX2");
                  }else if(producto.tipo == 5 && !subProductos[2]){
                    subProductos[2] = true;
                    this.activaProductoEspecifico("Culture_MX3");
                  }else if(producto.tipo == 6 && !subProductos[3]){
                    subProductos[3] = true;
                    this.activaProductoEspecifico("Culture_MX4");
                  }else if(producto.tipo == 7 && !subProductos[4]){
                    subProductos[4] = true;
                    this.activaProductoEspecifico("Culture_MX5");
                  }else if(producto.tipo == 10 && !subProductos[5]){
                    subProductos[5] = true;
                    this.activaProductoEspecifico("Culture_MX6");
                  }else if(producto.tipo == 11 && !subProductos[6]){
                    subProductos[6] = true;
                    this.activaProductoEspecifico("Culture_MX7");
                  }else if(producto.tipo == 12 && !subProductos[7]){
                    subProductos[7] = true;
                    this.activaProductoEspecifico("Culture_MX8");
                  }else if(producto.tipo == 14 && !subProductos[8]){
                    subProductos[8] = true;
                    this.activaProductoEspecifico("Culture_MX9");
                  }else if(producto.tipo == 15 && !subProductos[9]){
                    subProductos[9] = true;
                    this.activaProductoEspecifico("Culture_MX10");
                }else if(producto.tipo == 22 && !subProductos[10]){
                    subProductos[10] = true;
                    this.activaProductoEspecifico("Culture_MX11");
                }else if(producto.tipo == 23 && !subProductos[11]){
                    subProductos[11] = true;
                    this.activaProductoEspecifico("Culture_MX12");
                }else if(producto.tipo == 24 && !subProductos[12]){
                      subProductos[12] = true;
                      this.activaProductoEspecifico("Culture_MX13");
                }else if(producto.tipo == 25 && !subProductos[13]){
                          subProductos[13] = true;
                          this.activaProductoEspecifico("Culture_MX14");
                }else if(producto.tipo == 26 && !subProductos[14]){
                          subProductos[14] = true;
                          this.activaProductoEspecifico("Culture_MX15");
                }else if(producto.tipo == 27 && !subProductos[15]){
                          subProductos[15] = true;
                          this.activaProductoEspecifico("Culture_MX16");
                }else if(producto.tipo == 28 && !subProductos[16]){
                          subProductos[16] = true;
                          this.activaProductoEspecifico("Culture_MX17");
                }else if(producto.tipo == 30 && !subProductos[17]){
                          subProductos[17] = true;
                          this.activaProductoEspecifico("Culture_MX18");
                }else if(producto.tipo == 31 && !subProductos[18]){
                          subProductos[18] = true;
                          this.activaProductoEspecifico("Culture_MX19");
                }else if(producto.tipo == 32 && !subProductos[19]){
                          subProductos[19] = true;
                          this.activaProductoEspecifico("Culture_MX20");
                }
                });
              }else{
                console.log("entro este visne de ocultar");

                this.activaProductoEspecifico("Culture_v2");
              }

              break;
              case '2':
              console.log("productosCultureAuditV2",this.datosProd.productosCultureAuditV2);
              this.activaProductoEspecifico("Culture_v2");

              break;
              case '3': // instituto hk
              console.log("entro este caso de los productos culture Audit");
                localStorage.setItem('CultureCH','true');
                this.activaProductoEspecifico("Culture_v2");
                this.activaProductoEspecifico("Culture_CH");
                if(this.datosProd.productosCultureAudit.length > 0){ //Culture audit Normal
                  this.activaProductoEspecifico("Culture_CH1");
                }
                this.listaProdsCultureGral.forEach(producto => {
                  if(!producto.tipo && !subProductos[0]){
                    subProductos[0] = true;
                    this.activaProductoEspecifico("Culture_CH2");
                  }else if(producto.tipo==8 && !subProductos[1]){
                    subProductos[1] = true;
                    this.activaProductoEspecifico("Culture_CH3");
                  }else if(producto.tipo==16 && !subProductos[2]){
                    subProductos[2] = true;
                    this.activaProductoEspecifico("Culture_CH4");
                  }else if(producto.tipo==17 && !subProductos[3]){
                    subProductos[3] = true;
                    this.activaProductoEspecifico("Culture_CH5");
                  }
                });
              break;
              case '5': //Culture audit Turquia
                localStorage.setItem('CultureTurquia','Verdadero');
                localStorage.setItem('CultureMexico','false');
                this.activaProductoEspecifico("Culture_v2");
                this.activaProductoEspecifico("Culture_TR");
                this.listaProdsCultureGral.forEach(producto => {
                  if(!producto.tipo && !subProductos[0]){
                    subProductos[0] = true;
                    this.activaProductoEspecifico("Culture_TR1");
                  }else if(producto.tipo == 2 && !subProductos[1]){
                    subProductos[1] = true;
                    this.activaProductoEspecifico("Culture_TR2");
                  }else if(producto.tipo == 3 && !subProductos[2]){
                    subProductos[2] = true;
                    this.activaProductoEspecifico("Culture_TR3");
                  }
                });


              break;
              case '15':  //instituto ES
                localStorage.setItem('CultureESP','true');
              break;
              case '18': // instituto AMCO
                let alMenosUnICCA_nv1 = (producto) => producto.tipo == 18;
                if(this.listaProdsCultureGral.some(alMenosUnICCA_nv1)){
                  this.activaProductoEspecifico("Culture_v2");
                  this.activaProductoEspecifico("Culture_AMCO");

                }
              break;
              default:
                localStorage.setItem('CultureTurquia','Falso');
                localStorage.setItem('CultureMexico','false');
                localStorage.setItem('CultureCH','false');
            }
          }

          if (this.listaProdsCultureOzel.length>0) {
            switch (this.idInstituto){
              case '5':
              console.log('listaProdsCultureOzel',this.listaProdsCultureOzel);
                this.activaProductoEspecifico("Culture_TR_VOZEL");
                this.listaProdsCultureOzel.forEach(producto => {
                if(producto.tipo == 29){
                    this.activaProductoEspecifico("Culture_Ozel_TR1");
                  }
                });
                break;

              default:
                break;
            }
          }

          if(this.listaProdsCultureBriefCAYC.length > 0){
                this.activaProductoEspecifico("Culture_CAYC");
                let tiposProdActivo = [];
                this.listaProdsCultureBriefCAYC.forEach(producto => {
                  if(!tiposProdActivo.includes(producto.tipo)){
                    tiposProdActivo.push(producto.tipo)
                    switch (producto.tipo) {
                      case 20: this.activaProductoEspecifico("Culture_Brief"); break;
                      case 34: this.activaProductoEspecifico("Culture_AuditCAYC"); break;
                      case 21: this.activaProductoEspecifico("Culture_Brief_Culture_Audit"); break;
                    }
                  }
                });
              }


          if (this.listaProdsCultureICCA.length>0) {
            switch (this.idInstituto) {
              case '1':
              this.activaProductoEspecifico("cultureICCA");

                break;

              default:
                break;
            }
          }

          //activa el filemanager
          this.activaProductoEspecifico("cloud");

          if(this.parcheDesconocido1){ // se va a borrar cuando se valide el modulo
            this.activaProductoEspecifico("35encuesta");
          }

          if(localStorage.getItem('tipoIzzi')){
            this.navigation[0].children[0].translate = 'NAV.CERTIFICAR.TITULOIZZI';
            this.activaProductoEspecifico("cloud");   //al llamar de nuevo la funcion, oculta el producto visible
          }
          if(localStorage.getItem("institutoValidacionEtiquetas") == "15"){
            this.navigation[0].children[0].translate = 'NAV.CERTIFICAR.TITULO_ESPAIN';
            this.navigation[0].children[0].children[1].translate = 'NAV.CERTIFICAR.SUBPRODUCTOS.SPA';
            this.navigation[0].children[9].translate = 'NAV.CLOUD.TITULO_ESPANA';
            this.navigation[2].children[1].translate = 'NAV.RESULTS.ENLACES.TI_ESPANA';
            this.navigation[2].children[0].translate = 'NAV.RESULTS.ENLACES.TI_ESPANA';
            this.navigation[2].translate = 'NAV.RESULTS.ENLACES.TI_ESPANA';
          }

          //VALIDACION PRODUCTO ICI DE AMCO
          if(this.idInstituto == '18'){ // si es instituto AMCO
            if(this.statusProductosPadre.medir){  //si hay medires agreagdos
              if(this.listaProdsMedir[7].lista.length > 0){
                this.activaProductoEspecifico("medir");
                this.activaProductoEspecifico("medir_AMCO");
              }
            }
          }

          if(this.idInstituto == '19'){ // si es instituto AMCO
            if(this.statusProductosPadre.medir){  //si hay medires agreagdos
              if(this.listaProdsMedir[7].lista.length > 0){
                this.activaProductoEspecifico("medir");
                this.activaProductoEspecifico("medir_INNO");
              }
            }
          }

        break;
        case 2: case 3:
          this.activaProductoEspecifico("applications");  //oculta los productos
        break;
        case 4: case 5: //niveles resultados y resultados segmentados
          // this.activaProductoEspecifico("cloud"); //activa el filemanager
          if(this.idInstituto == '5'){
            this.activaProductoEspecifico("cloud"); // *lo oculta*
          }
        break;
        case 6:
          localStorage.setItem('Leveuser', '6');
          this.activaProductoEspecifico("certificarN35");
          this.activaProductoEspecifico("cloud");
          this.activaProductoEspecifico("35encuesta");
        break;
        case 8:   //nivel producto culture audit
        console.log('nivel producto culture audit');

          this.activaProductoEspecifico("cloud"); //activa el filemanager por defecto
          //activa los botones de acceso a cada culture audit
          if(this.datosProd.productosCultureAudit.length > 0) this.activaProductoEspecifico("Culture");
          if(this.listaProdsCultureGral.length > 0) this.activaProductoEspecifico("Culture_v2");
          if(this.datosProd.productosCultureAuditTR.length > 0) this.activaProductoEspecifico("Culture_tra");
          let subProductosCA = [false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false];
          console.log('this.idInstituto',this.idInstituto);

          switch (this.idInstituto) {
            case '1':
            if (this.listaProdsCultureMexico.length>0) {
              if(this.listaProdsCultureGral.length > 0){
                this.activaProductoEspecifico("Culture_v2");
                this.activaProductoEspecifico("Culture_MX");
              }

              this.listaProdsCultureGral.forEach(producto => {
                if(!producto.tipo && !subProductosCA[0]){
                  subProductosCA[0] = true;
                  this.activaProductoEspecifico("Culture_MX1");
                }else if(producto.tipo == 4 && !subProductosCA[1]){
                  subProductosCA[1] = true;
                  this.activaProductoEspecifico("Culture_MX2");
                }else if(producto.tipo == 5 && !subProductosCA[2]){
                  subProductosCA[2] = true;
                  this.activaProductoEspecifico("Culture_MX3");
                }else if(producto.tipo == 6 && !subProductosCA[3]){
                  subProductosCA[3] = true;
                  this.activaProductoEspecifico("Culture_MX4");
                }else if(producto.tipo == 7 && !subProductosCA[4]){
                  subProductosCA[4] = true;
                  this.activaProductoEspecifico("Culture_MX5");
                }else if(producto.tipo == 10 && !subProductosCA[5]){
                  subProductosCA[5] = true;
                  this.activaProductoEspecifico("Culture_MX6");
                }else if(producto.tipo == 11 && !subProductosCA[6]){
                  subProductosCA[6] = true;
                  this.activaProductoEspecifico("Culture_MX7");
                }else if(producto.tipo == 12 && !subProductosCA[7]){
                  subProductosCA[7] = true;
                  this.activaProductoEspecifico("Culture_MX8");
                }else if(producto.tipo == 14 && !subProductosCA[8]){
                  subProductosCA[8] = true;
                  this.activaProductoEspecifico("Culture_MX9");
                }else if(producto.tipo == 15 && !subProductosCA[9]){
                  subProductosCA[9] = true;
                  this.activaProductoEspecifico("Culture_MX10");
                }else if(producto.tipo == 22 && !subProductosCA[10]){
                  subProductosCA[10] = true;
                  this.activaProductoEspecifico("Culture_MX11");
                }else if(producto.tipo == 23 && !subProductosCA[11]){
                  subProductosCA[11] = true;
                  this.activaProductoEspecifico("Culture_MX12");
                }else if(producto.tipo == 24 && !subProductosCA[12]){
                  subProductosCA[12] = true;
                  this.activaProductoEspecifico("Culture_MX13");
                }else if(producto.tipo == 25 && !subProductosCA[13]){
                      subProductosCA[13] = true;
                      this.activaProductoEspecifico("Culture_MX14");
                    }else if(producto.tipo == 26 && !subProductosCA[14]){
                          subProductosCA[14] = true;
                          this.activaProductoEspecifico("Culture_MX15");
                        }else if(producto.tipo == 27 && !subProductosCA[15]){
                              subProductosCA[15] = true;
                              this.activaProductoEspecifico("Culture_MX16");
                            }else if(producto.tipo == 28 && !subProductosCA[16]){
                                  subProductosCA[16] = true;
                                  this.activaProductoEspecifico("Culture_MX17");
                                }else if(producto.tipo == 30 && !subProductosCA[17]){
                                      subProductosCA[17] = true;
                                      this.activaProductoEspecifico("Culture_MX18");
                                    }else if(producto.tipo == 31 && !subProductosCA[18]){
                                              subProductosCA[18] = true;
                                              this.activaProductoEspecifico("Culture_MX19");
                                    }else if(producto.tipo == 32 && !subProductosCA[19]){
                                              subProductosCA[19] = true;
                                              this.activaProductoEspecifico("Culture_MX20");
                                    }
              });

            }else{
              this.activaProductoEspecifico("Culture_v2");
            }
            break;
            case '2':
            if(this.listaProdsCultureBriefCAYC.length > 0){
              this.activaProductoEspecifico("Culture_CAYC");
              let tiposProdActivo = [];
              this.listaProdsCultureBriefCAYC.forEach(producto => {
                if(!tiposProdActivo.includes(producto.tipo)){
                  tiposProdActivo.push(producto.tipo)
                  switch (producto.tipo) {
                    case 20: this.activaProductoEspecifico("Culture_Brief"); break;
                    case 34: this.activaProductoEspecifico("Culture_AuditCAYC"); break;
                    case 21: this.activaProductoEspecifico("Culture_Brief_Culture_Audit"); break;
                  }
                }
              });

            }
            break;
            case '3': // instituto hk
            console.log("entro este caso de los productos culture Audit");

              if(this.datosProd.productosCultureAudit.length > 0 || this.listaProdsCultureGral.length > 0){
                this.activaProductoEspecifico("Culture_v2");
                this.activaProductoEspecifico("Culture_CH");
              }
              if(this.datosProd.productosCultureAudit.length > 0){ //Culture audit Normal
                this.activaProductoEspecifico("Culture_CH1");
              }
              this.listaProdsCultureGral.forEach(producto => {
                if(!producto.tipo && !subProductosCA[0]){
                  subProductosCA[0] = true;
                  this.activaProductoEspecifico("Culture_CH2");
                }else if(producto.tipo==8 && !subProductosCA[1]){
                  subProductosCA[1] = true;
                  this.activaProductoEspecifico("Culture_CH3");
                }else if(producto.tipo==16 && !subProductosCA[2]){
                  subProductosCA[2] = true;
                  this.activaProductoEspecifico("Culture_CH4");
                }else if(producto.tipo==17 && !subProductosCA[3]){
                  subProductosCA[3] = true;
                  this.activaProductoEspecifico("Culture_CH5");
                }
              });
            break;
            case '5': //Culture audit Turquia
              this.activaProductoEspecifico("cloud"); //si es TR le desactiva el filemanager
              if(this.listaProdsCultureGral.length > 0){
                this.activaProductoEspecifico("Culture_v2");
                this.activaProductoEspecifico("Culture_TR");
              }
              this.listaProdsCultureGral.forEach(producto => {
                if(!producto.tipo && !subProductosCA[0]){
                  subProductosCA[0] = true;
                  this.activaProductoEspecifico("Culture_TR1");
                }else if(producto.tipo == 2 && !subProductosCA[1]){
                  subProductosCA[1] = true;
                  this.activaProductoEspecifico("Culture_TR2");
                }else if(producto.tipo == 3 && !subProductosCA[2]){
                  subProductosCA[2] = true;
                  this.activaProductoEspecifico("Culture_TR3");
                }
              });

              if (this.listaProdsCultureOzel.length>0) {
                switch (this.idInstituto){
                  case '5':
                  console.log('listaProdsCultureOzel',this.listaProdsCultureOzel);
                    this.activaProductoEspecifico("Culture_TR_VOZEL");
                    this.listaProdsCultureOzel.forEach(producto => {
                    if(producto.tipo == 29){
                        this.activaProductoEspecifico("Culture_Ozel_TR1");
                      }
                    });
                    break;

                  default:
                    break;
                }
              }
            break;
            case '18': // instituto AMCO
              let alMenosUnICCA_nv8 = (producto) => producto.tipo == 18;
              if(this.listaProdsCultureGral.length > 0 && this.listaProdsCultureGral.some(alMenosUnICCA_nv8)){
                this.activaProductoEspecifico("Culture_v2");
                this.activaProductoEspecifico("Culture_AMCO");
              }
            break;
          }
        break;
        case 10:  // nivel RH compañia
          this.activaProductoEspecifico("cloud");
          //activa los botones de acceso a cada culture audit
          if(this.datosProd.productosCultureAudit.length > 0) this.activaProductoEspecifico("Culture");
          if(this.listaProdsCultureGral.length > 0) this.activaProductoEspecifico("Culture_v2");
          if(this.datosProd.productosCultureAuditTR.length > 0) this.activaProductoEspecifico("Culture_tra");
          let subProductosRH = [false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false];

        if(this.listaProdsActionGo[0].lista.length > 0 ) {
            this.activaProductoEspecifico("actionGO");
          }
          switch (this.idInstituto) {
            case '1': //MX
              if(this.listaProdsCultureGral.length > 0){
                this.activaProductoEspecifico("Culture_v2");
                this.activaProductoEspecifico("Culture_MX");
              }
              this.listaProdsCultureGral.forEach(producto => {
                if(!producto.tipo && !subProductosRH[0]){
                  subProductosRH[0] = true;
                  this.activaProductoEspecifico("Culture_MX1");
                }else if(producto.tipo == 4 && !subProductosRH[1]){
                  subProductosRH[1] = true;
                  this.activaProductoEspecifico("Culture_MX2");
                }else if(producto.tipo == 5 && !subProductosRH[2]){
                  subProductosRH[2] = true;
                  this.activaProductoEspecifico("Culture_MX3");
                }else if(producto.tipo == 6 && !subProductosRH[3]){
                  subProductosRH[3] = true;
                  this.activaProductoEspecifico("Culture_MX4");
                }else if(producto.tipo == 7 && !subProductosRH[4]){
                  subProductosRH[4] = true;
                  this.activaProductoEspecifico("Culture_MX5");
                }else if(producto.tipo == 10 && !subProductosRH[5]){
                  subProductosRH[5] = true;
                  this.activaProductoEspecifico("Culture_MX6");
                }else if(producto.tipo == 11 && !subProductosRH[6]){
                  subProductosRH[6] = true;
                  this.activaProductoEspecifico("Culture_MX7");
                }else if(producto.tipo == 12 && !subProductosRH[7]){
                  subProductosRH[7] = true;
                  this.activaProductoEspecifico("Culture_MX8");
                }else if(producto.tipo == 14 && !subProductosRH[8]){
                  subProductosRH[8] = true;
                  this.activaProductoEspecifico("Culture_MX9");
                }else if(producto.tipo == 15 && !subProductosRH[9]){
                  subProductosRH[9] = true;
                  this.activaProductoEspecifico("Culture_MX10");
                }else if(producto.tipo == 22 && !subProductosRH[10]){
                  subProductosRH[10] = true;
                  this.activaProductoEspecifico("Culture_MX11");
                }else if(producto.tipo == 23 && !subProductosRH[11]){
                  subProductosRH[11] = true;
                  this.activaProductoEspecifico("Culture_MX12");
                }else if(producto.tipo == 24 && !subProductosRH[12]){
                  subProductosRH[12] = true;
                  this.activaProductoEspecifico("Culture_MX13");
                }else if(producto.tipo == 25 && !subProductosRH[13]){
                      subProductosRH[13] = true;
                      this.activaProductoEspecifico("Culture_MX14");
                }else if(producto.tipo == 26 && !subProductosRH[14]){
                      subProductosRH[14] = true;
                      this.activaProductoEspecifico("Culture_MX15");
                }else if(producto.tipo == 27 && !subProductosRH[15]){
                      subProductosRH[15] = true;
                      this.activaProductoEspecifico("Culture_MX16");
                }else if(producto.tipo == 28 && !subProductosRH[16]){
                      subProductosRH[16] = true;
                      this.activaProductoEspecifico("Culture_MX17");
                    }else if(producto.tipo == 30 && !subProductosRH[17]){
                          subProductosRH[17] = true;
                          this.activaProductoEspecifico("Culture_MX18");
                        }else if(producto.tipo == 31 && !subProductosRH[18]){
                                  subProductosRH[18] = true;
                                  this.activaProductoEspecifico("Culture_MX19");
                        }else if(producto.tipo == 32 && !subProductosRH[19]){
                                  subProductosRH[19] = true;
                                  this.activaProductoEspecifico("Culture_MX20");
                        }
              });
            break;
            case '2':
            if(this.listaProdsCultureBriefCAYC.length > 0){
              this.activaProductoEspecifico("Culture_CAYC");
              let tiposProdActivo = [];
              this.listaProdsCultureBriefCAYC.forEach(producto => {
                if(!tiposProdActivo.includes(producto.tipo)){
                  tiposProdActivo.push(producto.tipo)
                  switch (producto.tipo) {
                    case 20: this.activaProductoEspecifico("Culture_Brief"); break;
                    case 34: this.activaProductoEspecifico("Culture_AuditCAYC"); break;
                    case 21: this.activaProductoEspecifico("Culture_Brief_Culture_Audit"); break;
                  }
                }
              });
            }
            break;
            case '3': // instituto hk
            console.log("entro este caso de los productos culture Audit");
              if(this.datosProd.productosCultureAudit.length > 0 || this.listaProdsCultureGral.length > 0){
                this.activaProductoEspecifico("Culture_v2");
                this.activaProductoEspecifico("Culture_CH");
              }
              if(this.datosProd.productosCultureAudit.length > 0){ //Culture audit Normal
                this.activaProductoEspecifico("Culture_CH1");
              }
              this.listaProdsCultureGral.forEach(producto => {
                if(!producto.tipo && !subProductosRH[0]){
                  subProductosRH[0] = true;
                  this.activaProductoEspecifico("Culture_CH2");
                }else if(producto.tipo==8 && !subProductosRH[1]){
                  subProductosRH[1] = true;
                  this.activaProductoEspecifico("Culture_CH3");
                }else if(producto.tipo==16 && !subProductosRH[1]){
                  subProductosRH[2] = true;
                  this.activaProductoEspecifico("Culture_CH4");
                }else if(producto.tipo==17 && !subProductosRH[1]){
                  subProductosRH[3] = true;
                  this.activaProductoEspecifico("Culture_CH5");
                }
              });
            break;
            case '5': //Culture audit Turquia
              if(this.listaProdsCultureGral.length > 0){
                this.activaProductoEspecifico("Culture_v2");
                this.activaProductoEspecifico("Culture_TR");
              }
              this.listaProdsCultureGral.forEach(producto => {
                if(!producto.tipo && !subProductosRH[0]){
                  subProductosRH[0] = true;
                  this.activaProductoEspecifico("Culture_TR1");
                }else if(producto.tipo == 2 && !subProductosRH[1]){
                  subProductosRH[1] = true;
                  this.activaProductoEspecifico("Culture_TR2");
                }else if(producto.tipo == 3 && !subProductosRH[2]){
                  subProductosRH[2] = true;
                  this.activaProductoEspecifico("Culture_TR3");
                }
              });
            break;
            case '11': // españa
              if(this.listaProdsCultureGral.length > 0){
                this.activaProductoEspecifico("Culture_v2");
                this.activaProductoEspecifico("Culture_AP");
              }
              this.listaProdsCultureGral.forEach(producto => {
                 if(producto.tipo==9){
                  this.activaProductoEspecifico("Culture_AP1");
                }
              });
            break;
          } //Final switch institutos usuario RH Compañia
        break;
        case 12: case 13: case 14:
          this.activaProductoEspecifico("applications");
        break;
        case 15: //Usuario Action go  o Lider Go
      console.log("this.datosUsuLogin",this.datosUsuLogin);
        if (this.datosUsuLogin.leader_go){this.activaProductoEspecifico("leaderGO");}
        if(this.datosUsuLogin.action_go){this.activaProductoEspecifico("actionGO");
        // this.activaProductoEspecifico("cloud"); //se activa aquí y posteriormente se desactiva en la funcion de valida productos
        // this.activaProductoEspecifico("file-server");
      }
          // this.activaProductoEspecifico("actionGO");
        break;
        case 16:
        if (this.datosUsuLogin.leader_go)this.activaProductoEspecifico("leaderGO");
        if(this.datosUsuLogin.action_go)this.activaProductoEspecifico("actionGO");
          // this.activaProductoEspecifico("actionGO");
        break;
        case 19:
        break;
        default:
          localStorage.setItem('Leveuser', '2');
      }
      console.log("Nueva navegación:",this.navigation);
    }

    validarHerramientas(nivel:number){
      this.activaProductoEspecifico("tools");
      //objeto para saber donde activar el knowledge base y ACTIVA EL KB SI APLICA EL CASO
      // let esperaBrokerConfig = setInterval( () => {
      //   if(this.brokerConfig != undefined){
      //     console.log("ID INSTITUTO:",this.idInstituto);
      //
      //     if(this.idInstituto.length > 0){
      //       let brokerBuscar = this.idInstituto == '0' ? '1' : this.idInstituto;
      //       const nivelesKB = this.brokerConfig.knowledgeBase.find(item => item.broker == parseInt(brokerBuscar));
      //       nivelesKB.niveles.includes(nivel.toString()) ? this.activaProductoEspecifico("knowledge-base") : false;
      //     } else{
      //       this.activaProductoEspecifico("knowledge-base");
      //     }
      //     clearInterval(esperaBrokerConfig);
      //   }
      // },0);

      switch(nivel){
        case 1: // nivel empresa
          if(!localStorage.getItem('tipoIzzi')){
            // if (this.idInstituto!='19') {
              this.activaProductoEspecifico("requirementsdetailMX");

            // }
            let conProductos = false;
            //activa los botones de acceso a cada certificar
            if(this.listaProdsCertificar[0].lista.length > 0){ this.activaProductoEspecifico("certify_0_RT"); conProductos = true;}
            if(this.listaProdsCertificar[1].lista.length > 0){ this.activaProductoEspecifico("certify_1_RT"); conProductos = true;}
            if(this.listaProdsCertificar[2].lista.length > 0){ this.activaProductoEspecifico("certify_2_RT"); conProductos = true;}
            if(this.listaProdsCertificar[3].lista.length > 0){
              this.activaProductoEspecifico("certify_3_RT"); conProductos = true;
              if (this.idInstituto=="19") {
              this.activaProductoEspecifico("certify_3_RT",null,null, 'NAV.medir_INNO.TITULO');
              }
            }
            if(this.listaProdsCertificar[4].lista.length > 0){ this.activaProductoEspecifico("certify_4_RT"); conProductos = true;}
            if(this.listaProdsCertificar[5].lista.length > 0){ this.activaProductoEspecifico("certify_6_RT"); conProductos = true;}
            //activa los botones de acceso a cada medir
            if(this.listaProdsMedir[0].lista.length > 0){ this.activaProductoEspecifico("medir_0_RT"); conProductos = true;}
            if(this.listaProdsMedir[1].lista.length > 0){ this.activaProductoEspecifico("medir_1_RT"); conProductos = true;}
            if(this.listaProdsMedir[2].lista.length > 0){ this.activaProductoEspecifico("medir_2_RT"); conProductos = true;}
            if(this.listaProdsMedir[3].lista.length > 0){ this.activaProductoEspecifico("medir_3_RT"); conProductos = true;}
            if(this.listaProdsMedir[4].lista.length > 0){ this.activaProductoEspecifico("medir_4_RT"); conProductos = true;}
            if(this.listaProdsMedir[5].lista.length > 0){ this.activaProductoEspecifico("medir_5_RT"); conProductos = true;}
            if(this.listaProdsMedir[6].lista.length > 0){ this.activaProductoEspecifico("medir_6_RT"); conProductos = true;}
            if(this.listaProdsMedir[7].lista.length > 0){
              this.activaProductoEspecifico("medir_7_RT"); conProductos = true;
              if (this.idInstituto=="19") {
              this.activaProductoEspecifico("medir_7_RT",null,null, 'NAV.medir_INNO.TITULO');
              }
          }
            //activa los botones de acceso a cada pulse
            if(this.listaProdsPulse[0].lista.length > 0){ this.activaProductoEspecifico("pulse_RT"); conProductos = true;}
            if(this.listaProdsPulse[1].lista.length > 0){ this.activaProductoEspecifico("pulse_t1_RT"); conProductos = true;}
            // if(this.datosProd.productosFocusArea.length > 0) this.activaProductoEspecifico("focus_RT");
            if(this.listaProdsFocus[1].lista.length > 0){ this.activaProductoEspecifico("focus_RT"); conProductos = true;}
            if(this.datosProd.productosNorma35.length > 0){
              let norma35:any[]=[];
              let norma35V3:any[]=[];
            this.datosProd.productosNorma35.forEach(norma => {
              switch (norma.tipo) {
                case 1:
                norma35.push(norma);
                break;
                case 4:
                norma35V3.push(norma);
                break;

                default:
                  break;
              }
            });

            if (norma35.length>0) {
              this.activaProductoEspecifico("certificarN35_RT"); conProductos = true;
            }
            if (norma35V3.length>0) {
              this.activaProductoEspecifico("certificarN35V3_RT"); conProductos = true;
            }
            }
            if(this.listaProdsCerAmco[0].lista.length > 0){ this.activaProductoEspecifico("amco_RT"); conProductos = true;}
            if(this.listaProdsCerAmco[1].lista.length > 0){ this.activaProductoEspecifico("traba_digno_RT"); conProductos = true;}
            if(this.listaProdsCerAmco[2].lista.length > 0){ this.activaProductoEspecifico("prime_emple_RT"); conProductos = true;}

            if(!conProductos){
              this.activaProductoEspecifico("requirementsdetailMX");
            }
          }
          if(this.datosProd.productosNorma35.length > 0){
            this.activaProductoEspecifico("questions");
            if(this.datosProd.productosNorma35[0].tipo){
              if(this.datosProd.productosNorma35[0].tipo == 2){
                this.activaProductoEspecifico("videos_inst");
              }else{
                this.activaProductoEspecifico("videos_admin");
                this.activaProductoEspecifico("videos_tips");
              }
            }else{
              this.activaProductoEspecifico("videos_admin");
              this.activaProductoEspecifico("videos_tips");
            }
          }
          //VALIDACION PRODUCTO ICI DE AMCO
          if(this.idInstituto == '18'){ // si es instituto AMCO
            if(this.statusProductosPadre.medir){  //si hay medires agreagdos
              if(this.listaProdsMedir[7].lista.length > 0){
                this.activaProductoEspecifico("medir_7_RT", null, null, 'NAV.MEDIR.SUBPRODUCTOS.8');
              }
            }
          }
          //VALIDACION PRODUCTO Innovation DE Innovation
          if(this.idInstituto == '19'){ // si es instituto Innovation
            if(this.statusProductosPadre.medir){  //si hay medires agreagdos
              if(this.listaProdsMedir[7].lista.length > 0){
                this.activaProductoEspecifico("medir_8_RT", null, null, 'Innovation survey');
              }
            }
          }
          if(this.idInstituto != '19'){
            if(this.listaProdsCertificar[0].lista.length > 0 || this.listaProdsCertificar[1].lista.length > 0||this.listaProdsCertificar[2].lista.length >0||this.listaProdsCertificar[3].lista.length >0){
              this.activaProductoEspecifico("web-company-profile");
            }

          }
        break;
        case 2:
          this.activaProductoEspecifico("ods");
          this.activaProductoEspecifico("perfs");
          this.activaProductoEspecifico("consultarEncuesta");
          this.activaProductoEspecifico("calendSurvey");
          this.activaProductoEspecifico("rawdataFinder");
          this.activaProductoEspecifico("requirementsdetail");
          if(this.idInstituto != '19'){
            this.activaProductoEspecifico("changelog", null, null, null, this.versionActual);
            this.activaProductoEspecifico("knowledge-base");
          }

        break;
        case 3:
          this.activaProductoEspecifico("ods");
          this.activaProductoEspecifico("perfs");
          this.activaProductoEspecifico("consultarEncuesta");
          this.activaProductoEspecifico("calendSurvey");
          this.activaProductoEspecifico("rawdataFinder");
          // this.activaProductoEspecifico("auditoriaAutomatizada");
          this.activaProductoEspecifico("log");
          this.activaProductoEspecifico("requirementsdetail");
          this.activaProductoEspecifico("consultarRequerimientos");
          this.activaProductoEspecifico("editorBroker");
          this.activaProductoEspecifico("changelog", null, null, null, this.versionActual);
          this.activaProductoEspecifico("knowledge-base");
          this.activaProductoEspecifico("controlEncuesta");
          this.activaProductoEspecifico("genericSurvey");
          if(this.datosProd){
            this.activaProductoEspecifico("questions");
            if(this.datosProd.productosNorma35[0].tipo){
              if(this.datosProd.productosNorma35[0].tipo == 2){
                this.activaProductoEspecifico("videos_inst");
              }else{
                this.activaProductoEspecifico("videos_admin");
              }
            }else{
              this.activaProductoEspecifico("videos_admin");
            }
          }
        break;
        case 4: // nivel resultados
          if(this.idInstituto == '5'){ // Turquia
            this.activaProductoEspecifico("requirementsdetailMX");
            //activa los botones de acceso a cada certificar
            if(this.listaProdsCertificar[0].lista.length > 0) this.activaProductoEspecifico("certify_0_RT");
            if(this.listaProdsCertificar[1].lista.length > 0) this.activaProductoEspecifico("certify_1_RT");
            if(this.listaProdsCertificar[2].lista.length > 0) this.activaProductoEspecifico("certify_2_RT");
            if(this.listaProdsCertificar[3].lista.length > 0) this.activaProductoEspecifico("certify_3_RT");
            if(this.listaProdsCertificar[4].lista.length > 0) this.activaProductoEspecifico("certify_4_RT");
            //activa los botones de acceso a cada medir
            if(this.listaProdsMedir[0].lista.length > 0) this.activaProductoEspecifico("medir_0_RT");
            if(this.listaProdsMedir[1].lista.length > 0) this.activaProductoEspecifico("medir_1_RT");
            if(this.listaProdsMedir[2].lista.length > 0) this.activaProductoEspecifico("medir_2_RT");
            if(this.listaProdsMedir[3].lista.length > 0) this.activaProductoEspecifico("medir_3_RT");
            if(this.listaProdsMedir[4].lista.length > 0) this.activaProductoEspecifico("medir_4_RT");
            if(this.listaProdsMedir[5].lista.length > 0) this.activaProductoEspecifico("medir_5_RT");
            if(this.listaProdsMedir[6].lista.length > 0) this.activaProductoEspecifico("medir_6_RT");
            if(this.listaProdsMedir[7].lista.length > 0) this.activaProductoEspecifico("medir_7_RT");
            //activa los botones de acceso a cada pulse
            if(this.listaProdsPulse[0].lista.length > 0) this.activaProductoEspecifico("pulse_RT");
            if(this.listaProdsPulse[1].lista.length > 0) this.activaProductoEspecifico("pulse_t1_RT");
            if(this.datosProd.productosFocusArea.length > 0) this.activaProductoEspecifico("focus_RT");
            if(this.datosProd.productosNorma35.length > 0){
              let norma35:any[]=[];
              let norma35V3:any[]=[];
            this.datosProd.productosNorma35.forEach(norma => {
              switch (norma.tipo) {
                case 1:
                norma35.push(norma);
                break;
                case 4:
                norma35V3.push(norma);
                break;

                default:
                  break;
              }
            });

            if (norma35.length>0) {
              this.activaProductoEspecifico("certificarN35_RT");
            }
            if (norma35V3.length>0) {
              this.activaProductoEspecifico("certificarN35V3_RT");
            }
            }
          }
          console.log("holis");
          if(this.listaProdsCertificar[0].lista.length > 0 || this.listaProdsCertificar[1].lista.length > 0||this.listaProdsCertificar[2].lista.length >0||this.listaProdsCertificar[3].lista.length >0){
            // this.activaProductoEspecifico("web-company-profile");
          }
          this.activaProductoEspecifico("applications");
          this.activaProductoEspecifico("tools");

        break;
        case 5: // nivel resultados segmentados
          if(!localStorage.getItem('tipoIzzi')){
            if(this.idInstituto == '5'){ // Turquia
              this.activaProductoEspecifico("requirementsdetailMX");
              //activa los botones de acceso a cada certificar
              if(this.listaProdsCertificar[0].lista.length > 0) this.activaProductoEspecifico("certify_0_RT");
              if(this.listaProdsCertificar[1].lista.length > 0) this.activaProductoEspecifico("certify_1_RT");
              if(this.listaProdsCertificar[2].lista.length > 0) this.activaProductoEspecifico("certify_2_RT");
              if(this.listaProdsCertificar[3].lista.length > 0) this.activaProductoEspecifico("certify_3_RT");
              if(this.listaProdsCertificar[4].lista.length > 0) this.activaProductoEspecifico("certify_4_RT");
              //activa los botones de acceso a cada medir
              if(this.listaProdsMedir[0].lista.length > 0) this.activaProductoEspecifico("medir_0_RT");
              if(this.listaProdsMedir[1].lista.length > 0) this.activaProductoEspecifico("medir_1_RT");
              if(this.listaProdsMedir[2].lista.length > 0) this.activaProductoEspecifico("medir_2_RT");
              if(this.listaProdsMedir[3].lista.length > 0) this.activaProductoEspecifico("medir_3_RT");
              if(this.listaProdsMedir[4].lista.length > 0) this.activaProductoEspecifico("medir_4_RT");
              if(this.listaProdsMedir[5].lista.length > 0) this.activaProductoEspecifico("medir_5_RT");
              if(this.listaProdsMedir[6].lista.length > 0) this.activaProductoEspecifico("medir_6_RT");
              if(this.listaProdsMedir[7].lista.length > 0) this.activaProductoEspecifico("medir_7_RT");
              //activa los botones de acceso a cada pulse
              if(this.listaProdsPulse[0].lista.length > 0) this.activaProductoEspecifico("pulse_RT");
              if(this.listaProdsPulse[1].lista.length > 0) this.activaProductoEspecifico("pulse_t1_RT");
              if(this.datosProd.productosFocusArea.length > 0) this.activaProductoEspecifico("focus_RT");
              if(this.datosProd.productosNorma35.length > 0){
                let norma35:any[]=[];
                let norma35V3:any[]=[];
              this.datosProd.productosNorma35.forEach(norma => {
                switch (norma.tipo) {
                  case 1:
                  norma35.push(norma);
                  break;
                  case 4:
                  norma35V3.push(norma);
                  break;

                  default:
                    break;
                }
              });

              if (norma35.length>0) {
                this.activaProductoEspecifico("certificarN35_RT");
              }
              if (norma35V3.length>0) {
                this.activaProductoEspecifico("certificarN35V3_RT");
              }
              }
            }
          }
          if(this.datosProd.productosNorma35.length > 0){
            this.activaProductoEspecifico("questions");
            if(this.datosProd.productosNorma35[0].tipo){
              if(this.datosProd.productosNorma35[0].tipo == 2){
                this.activaProductoEspecifico("videos_inst");
              }else{
                this.activaProductoEspecifico("videos_admin");
                this.activaProductoEspecifico("videos_tips");
              }
            }else{
              this.activaProductoEspecifico("videos_admin");
              this.activaProductoEspecifico("videos_tips");
            }
          }
        break;
        case 6:
          this.activaProductoEspecifico("tools");
        break;
        case 8:  // nivel Producto Culture Audit
          this.activaProductoEspecifico("tools");
          // this.activaProductoEspecifico("requirementsdetail");
        break;
        case 10:  // nivel Compañia RH
          this.activaProductoEspecifico("requirementsdetailMX");
          //activa los botones de acceso a cada certificar
          if(this.listaProdsCertificar[0].lista.length > 0) this.activaProductoEspecifico("certify_0_RT");
          if(this.listaProdsCertificar[1].lista.length > 0) this.activaProductoEspecifico("certify_1_RT");
          if(this.listaProdsCertificar[2].lista.length > 0) this.activaProductoEspecifico("certify_2_RT");
          if(this.listaProdsCertificar[3].lista.length > 0) this.activaProductoEspecifico("certify_3_RT");
          if(this.listaProdsCertificar[4].lista.length > 0) this.activaProductoEspecifico("certify_4_RT");
          //activa los botones de acceso a cada medir
          if(this.listaProdsMedir[0].lista.length > 0) this.activaProductoEspecifico("medir_0_RT");
          if(this.listaProdsMedir[1].lista.length > 0) this.activaProductoEspecifico("medir_1_RT");
          if(this.listaProdsMedir[2].lista.length > 0) this.activaProductoEspecifico("medir_2_RT");
          if(this.listaProdsMedir[3].lista.length > 0) this.activaProductoEspecifico("medir_3_RT");
          if(this.listaProdsMedir[4].lista.length > 0) this.activaProductoEspecifico("medir_4_RT");
          if(this.listaProdsMedir[5].lista.length > 0) this.activaProductoEspecifico("medir_5_RT");
          if(this.listaProdsMedir[6].lista.length > 0) this.activaProductoEspecifico("medir_6_RT");
          if(this.listaProdsMedir[7].lista.length > 0) this.activaProductoEspecifico("medir_7_RT");
          //activa los botones de acceso a cada pulse
          if(this.listaProdsPulse[0].lista.length > 0) this.activaProductoEspecifico("pulse_RT");
          if(this.listaProdsPulse[1].lista.length > 0) this.activaProductoEspecifico("pulse_t1_RT");
          if(this.datosProd.productosFocusArea.length > 0) this.activaProductoEspecifico("focus_RT");
          if(this.datosProd.productosNorma35.length > 0){
            let norma35:any[]=[];
            let norma35V3:any[]=[];
          this.datosProd.productosNorma35.forEach(norma => {
            switch (norma.tipo) {
              case 1:
              norma35.push(norma);
              break;
              case 4:
              norma35V3.push(norma);
              break;

              default:
                break;
            }
          });

          if (norma35.length>0) {
            this.activaProductoEspecifico("certificarN35_RT");
          }
          if (norma35V3.length>0) {
            this.activaProductoEspecifico("certificarN35V3_RT");
          }
          }
        break;
        case 11:  ////nivel Izzi
          this.activaProductoEspecifico("ods");
          this.activaProductoEspecifico("perfs");
          this.activaProductoEspecifico("requirementsdetailMX");
          //activa los botones de acceso a cada certificar
          if(this.listaProdsCertificar[0].lista.length > 0) this.activaProductoEspecifico("certify_0_RT");
          if(this.listaProdsCertificar[1].lista.length > 0) this.activaProductoEspecifico("certify_1_RT");
          if(this.listaProdsCertificar[2].lista.length > 0) this.activaProductoEspecifico("certify_2_RT");
          if(this.listaProdsCertificar[3].lista.length > 0) this.activaProductoEspecifico("certify_3_RT");
          if(this.listaProdsCertificar[4].lista.length > 0) this.activaProductoEspecifico("certify_4_RT");
          //activa los botones de acceso a cada medir
          if(this.listaProdsMedir[0].lista.length > 0) this.activaProductoEspecifico("medir_0_RT");
          if(this.listaProdsMedir[1].lista.length > 0) this.activaProductoEspecifico("medir_1_RT");
          if(this.listaProdsMedir[2].lista.length > 0) this.activaProductoEspecifico("medir_2_RT");
          if(this.listaProdsMedir[3].lista.length > 0) this.activaProductoEspecifico("medir_3_RT");
          if(this.listaProdsMedir[4].lista.length > 0) this.activaProductoEspecifico("medir_4_RT");
          if(this.listaProdsMedir[5].lista.length > 0) this.activaProductoEspecifico("medir_5_RT");
          if(this.listaProdsMedir[6].lista.length > 0) this.activaProductoEspecifico("medir_6_RT");
          if(this.listaProdsMedir[7].lista.length > 0) this.activaProductoEspecifico("medir_7_RT");
          //activa los botones de acceso a cada pulse
          if(this.listaProdsPulse[0].lista.length > 0) this.activaProductoEspecifico("pulse_RT");
          if(this.listaProdsPulse[1].lista.length > 0) this.activaProductoEspecifico("pulse_t1_RT");
          if(this.datosProd.productosFocusArea.length > 0) this.activaProductoEspecifico("focus_RT");
          if(this.datosProd.productosNorma35.length > 0){
            let norma35:any[]=[];
            let norma35V3:any[]=[];
          this.datosProd.productosNorma35.forEach(norma => {
            switch (norma.tipo) {
              case 1:
              norma35.push(norma);
              break;
              case 4:
              norma35V3.push(norma);
              break;

              default:
                break;
            }
          });

          if (norma35.length>0) {
            this.activaProductoEspecifico("certificarN35_RT");
          }
          if (norma35V3.length>0) {
            this.activaProductoEspecifico("certificarN35V3_RT");
          }
          }
        break;
        case 12: case 13: case 14:
          this.activaProductoEspecifico("tools");
        break;
        case 15:
        this.activaProductoEspecifico("tools");
        break;
        case 18:
        this.activaProductoEspecifico("web-company-profile");
        break;
        case 19:
        this.activaProductoEspecifico("applications");
        this.activaProductoEspecifico("tools");
        // this.activaProductoEspecifico("web-company-profile");
        break;
      }
    }

    validarResultados(nivel:number){
      switch (nivel) {
        case 1: // nivel empresa
          if(this.datosProd.productosResultados.length > 0){
            this.activaProductoEspecifico("results");
            this.activaProductoEspecifico("ti");
          }else{
            console.log("entro ",this.statusProductosPadre);
            for(let k in this.statusProductosPadre){
              if(this.statusProductosPadre[k] == true){ // si alguno de los productos padre esta activo, se muestra el boton de resultados
                this.activaProductoEspecifico("results");
                this.activaProductoEspecifico("ti");
                break;
              }
            }
          }
          if (this.datosProd.productosResultadosGoFlow!=undefined) {
            if(this.datosProd.productosResultadosGoFlow.length > 0){
              this.activaProductoEspecifico("ti_goFlow");
            }

          }
        break;
        case 2: case 3: break;
        case 4: // nivel resultados
          this.activaProductoEspecifico("results");
          this.activaProductoEspecifico("ti");
          // if(this.idInstituto == '5'){ // Turquia
          //   this.activaProductoEspecifico("applications");
          //   this.activaProductoEspecifico("cloud");
          //   this.activaProductoEspecifico("tools");
          //   this.activaProductoEspecifico("requirementsdetailMX");
          // }
        break;
        case 5: // nivel resultados segmentados
          this.activaProductoEspecifico("results");
          this.activaProductoEspecifico("ti");
          // if(this.idInstituto == '5'){ // Turquia
          //   this.activaProductoEspecifico("applications");
          //   this.activaProductoEspecifico("cloud");
          //   this.activaProductoEspecifico("tools");
          //   this.activaProductoEspecifico("requirementsdetailMX");
          // }
        break;
        case 7:  // resultados covid
          this.activaProductoEspecifico("resultsCovid");
          this.activaProductoEspecifico("ti_covid");
        break;
        case 8: break; // nivel producto CA
        case 10:  // nivel RH compañia
          this.activaProductoEspecifico("results");
          this.activaProductoEspecifico("ti");
          if(this.datosProd.productosResultados5cero.length > 0){
            this.activaProductoEspecifico("ti_5");
          }
        break;
        case 12:  // nivel actiongo
          this.activaProductoEspecifico("results");
          // if(this.idInstituto == '8'){ //izzi
            // this.activaProductoEspecifico("actionGo");
            this.activaProductoEspecifico("actionGoLevel12");
          // }
        break;
        case 14:  // actiongo lider
          this.activaProductoEspecifico("results");
          // if(this.idInstituto == '8'){ //izzi
            this.activaProductoEspecifico("actionGoAdminLider");
          // }
        break;
        case 13:  // nivel segmentados y actiongo
          this.activaProductoEspecifico("results");
          // if(this.idInstituto == '8'){ //izzi
            this.activaProductoEspecifico("ti");
            this.activaProductoEspecifico("actionGoLevel13");
          // }
        break;
        case 15:  // nivel segmentados y actiongo

        break;
        case 18:  // nivel Web company profile

        break;
        case 19:  // nivel resultados 2.0
        this.activaProductoEspecifico("results");
        this.activaProductoEspecifico("ti");
        break;
        default:
          this.activaProductoEspecifico("tools");
          if(
            this.listaProdsCertificar[0].lista.length > 0 ||
            this.listaProdsCertificar[1].lista.length > 0 ||
            this.listaProdsCertificar[2].lista.length > 0 ||
            this.listaProdsCertificar[3].lista.length > 0 ||
            this.listaProdsMedir[0].lista.length > 0 ||
            this.listaProdsMedir[1].lista.length > 0 ||
            this.listaProdsMedir[2].lista.length > 0 ||
            this.listaProdsMedir[3].lista.length > 0 ||
            this.listaProdsMedir[4].lista.length > 0 ||
            this.listaProdsMedir[5].lista.length > 0 ||
            this.listaProdsMedir[6].lista.length > 0 ||
            this.listaProdsMedir[7].lista.length > 0 ||
            this.listaProdsPulse[0].lista.length > 0 ||
            this.listaProdsPulse[1].lista.length > 0 ||
            this.datosProd.productosResultados4all.length > 0
          ){
            this.activaProductoEspecifico("results");
            this.activaProductoEspecifico("ti");
            if(this.datosProd.productosResultados5cero.length > 0){
              this.activaProductoEspecifico("ti_5");
            }
          }
      }
    }

    filtraProductosMedir(){
      this.listaProdsCertificar = [];
      this.listaProdsCerAmco = [];
      this.listaProdsMedir = [];
      this.listaProdsPulse = [];
      this.listaProdsFocus = [];
      this.listaProdsLeaderGo = [];
      this.listaProdsCultureICCA = [];
      this.listaProdsCultureGral = [];
      this.listaProdsCultureOzel = [];
      this.listaProdsCultureBriefCAYC = [];
      this.listaProdsCultureMexico = [];
      //arreglos certificar
      let arrayCert_1:any[] = [];
      let arrayCert_2:any[] = [];
      let arrayCert_3:any[] = [];
      let arrayCert_4:any[] = [];
      let arrayCert_5:any[] = [];
      let arrayCert_6:any[] = [];
      //declaración de arreglos de productos medir
      let arrayMedir_0:any[] = [];
      let arrayMedir_1:any[] = [];
      let arrayMedir_2:any[] = [];
      let arrayMedir_3:any[] = [];
      let arrayMedir_4:any[] = [];
      let arrayMedir_5:any[] = [];
      let arrayMedir_6:any[] = [];
      let arrayMedir_7:any[] = [];
      //declaración de arreglos de productos pulse
      let arrayPulse_0:any[] = [];
      let arrayPulse_1:any[] = [];
      let arrayFocus_0:any[] = [];
      let arrayFocus_1:any[] = [];
      let arrayLeaderGo_0:any[] = [];
      let arrayActionGo_0:any[] = [];
      let arrayCerAmco:any[] = [];
      let arrayCerTrabDig:any[] = [];
      let arrayCerPriEmpl:any[] = [];
      let arrayCultureGral:any[] = [];
      let arrayCultureBriefCAYC:any[] = [];
      let arrayCultureICCA:any[] = [];
      let arrayCultureOzel:any[] = [];

      //filtrado de certificar
      this.datosProd.productosCertificar.forEach((producto: any) => {
        if(this.idsProductosCert3Falsos.findIndex(item => item.id == producto.idProducto) == -1){ //si el id del producto no esta en el arreglo
          switch (producto.tipo) {
            case 1: arrayCert_1.push(producto); break;
            case 2: arrayCert_2.push(producto); break;
            case 3: arrayCert_3.push(producto); break;
            case 4: arrayCert_4.push(producto); break;
            case 9: arrayCert_5.push(producto); break;
            case 11: arrayCert_6.push(producto); break;
          }
          this.statusProductosPadre.certificar = true;
        }
        else{
          switch (producto.idProducto) {
            case 41:  //medir 3.0
            arrayMedir_7.push(producto);
            this.idsProductosCert3Falsos[0].activo = true;
            this.statusProductosPadre.medir = true;
            break;
            case 42:  //pulse 3.0
            arrayPulse_1.push(producto);
            this.idsProductosCert3Falsos[1].activo = true;
            this.statusProductosPadre.pulse = true;
            break;
            case 43:  //focus 3.0
            arrayFocus_1.push(producto);
            this.idsProductosCert3Falsos[2].activo = true;
            // this.statusProductosPadre.focus = true;
            break;
            case 53:  //focus 3.0
            arrayLeaderGo_0.push(producto);
            this.idsProductosCert3Falsos[3].activo = true;
            // this.statusProductosPadre.focus = true;
            break;
            case 54:  //ActionGO 3.0
            arrayActionGo_0.push(producto);
            this.idsProductosCert3Falsos[4].activo = true;
            // this.statusProductosPadre.focus = true;
            break;
            case 56:  //ActionGO 3.0
            arrayCerAmco.push(producto);
            this.idsProductosCert3Falsos[5].activo = true;

            break;
            case 57:  //ActionGO 3.0
            arrayCerTrabDig.push(producto);
            this.idsProductosCert3Falsos[6].activo = true;
            break;
            case 58:  //ActionGO 3.0
            arrayCerPriEmpl.push(producto);
            this.idsProductosCert3Falsos[7].activo = true;
            break;
          }
        }
      });
      //filtrado de medir
      this.datosProd.productosMedir.forEach(producto => {
        arrayMedir_0.push(producto);
        this.statusProductosPadre.medir = true;
      });
      this.datosProd.productosMedir2.forEach(producto => {
        switch(producto.tipo){
          case 1: arrayMedir_1.push(producto); break;
          case 2: arrayMedir_2.push(producto); break;
          case 3: arrayMedir_3.push(producto); break;
          case 4: arrayMedir_4.push(producto); break;
          case 5: arrayMedir_5.push(producto); break;
          case 6: arrayMedir_6.push(producto); break;
        }
        this.statusProductosPadre.medir = true;
      });

      //filtrado de pulse
      this.datosProd.productosPulseCheck.forEach(producto => {
        arrayPulse_0.push(producto);
        this.statusProductosPadre.pulse = true;
      });
      //filtrado de focus
      this.datosProd.productosFocusArea.forEach(producto => {
        arrayFocus_0.push(producto);
        // this.statusProductosPadre.focus = true;
      });

      this.listaProdsCertificar.push(
        {id:1, lista: arrayCert_1},
        {id:20, lista: arrayCert_2},
        {id:27, lista: arrayCert_3},
        {id:40, lista: arrayCert_4},
        {id:69, lista: arrayCert_5},
        {id:75, lista: arrayCert_6},
      );

      this.listaProdsMedir.push(
        {id:2, lista: arrayMedir_0},
        {id:11, lista: arrayMedir_1},
        {id:12, lista: arrayMedir_2},
        {id:13, lista: arrayMedir_3},
        {id:14, lista: arrayMedir_4},
        {id:15, lista: arrayMedir_5},
        {id:16, lista: arrayMedir_6},
        {id:41, lista: arrayMedir_7}, //medir 3.0
      );

      this.listaProdsPulse.push(
        {id:4, lista: arrayPulse_0},
        {id:42, lista: arrayPulse_1},
      );

      this.listaProdsFocus.push(
        {id:4, lista: arrayFocus_0},
        {id:43, lista: arrayFocus_1},
      );

      this.listaProdsLeaderGo.push(
        {id:53, lista: arrayLeaderGo_0},

      );
      this.listaProdsActionGo.push(
        {id:54, lista: arrayActionGo_0},

      );
      this.listaProdsCerAmco.push(
        {id:56, lista: arrayCerAmco},
        {id:57, lista: arrayCerTrabDig},
        {id:58, lista: arrayCerPriEmpl},
      );
      if (this.listaProdsCerAmco[0].lista.length>0||this.listaProdsCerAmco[1].lista.length>0||this.listaProdsCerAmco[2].lista.length>0) {
        this.statusProductosPadre.cerAmco = true;
      }
      console.log('this.listaProdsCerAmco',this.listaProdsCerAmco);



      this.datosProd.productosCultureAuditV2.forEach(tipoId => {
        if (tipoId.tipo==19) {
          arrayCultureICCA.push(tipoId);

        }else if (tipoId.tipo==20|| tipoId.tipo==21 || tipoId.tipo == 34) {
          arrayCultureBriefCAYC.push(tipoId);
        }else if (tipoId.tipo==29) {
          arrayCultureOzel.push(tipoId);
        }else{
          arrayCultureGral.push(tipoId);
        }

        if (!tipoId.tipo) {
          this.listaProdsCultureMexico.push(tipoId);
        }

        if(this.idsProductosCultureAuditMx.findIndex(item => item.tipo == tipoId.tipo) != -1){
          // console.log('tipoId.tipo',tipoId.tipo);
          //si el id del producto no esta en el arreglo
          this.listaProdsCultureMexico.push(tipoId);
        }


      });
      this.listaProdsCultureICCA= arrayCultureICCA;
      this.listaProdsCultureGral=arrayCultureGral;
      this.listaProdsCultureOzel=arrayCultureOzel;
      this.listaProdsCultureBriefCAYC=arrayCultureBriefCAYC;

      console.log("listaProdsCultureICCA",this.listaProdsCultureICCA);
      console.log("listaProdsCultureGral",this.listaProdsCultureGral);
      console.log("listaProdsCultureMexico",this.listaProdsCultureMexico);
      console.log("listaProdsCultureBriefCAYC",this.listaProdsCultureBriefCAYC);
      console.log("listaProdsCultureOzel",this.listaProdsCultureOzel);

    }

    creaNavLinks() {      //Subscribe to the current navigation changes
      this._fuseNavigationService.onNavigationChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
        // Load the navigation
        this.navigation = this._fuseNavigationService.getCurrentNavigation();
        // Mark for check
        this._changeDetectorRef.markForCheck();
        //coloca el idioma seleccionado nuevamente para corregir cuando no se pinta correctamente
        // setTimeout(() => {
        //   let actLang = this._translateService.currentLang;
        //   this._translateService.use('es');
        //   this._translateService.use(actLang);
        // });
        setTimeout(() => {
          this._translateService.setDefaultLang('es');
          this._translateService.setDefaultLang('en');
        });
      });
      // Subscribe to navigation item
      merge(
        this._fuseNavigationService.onNavigationItemAdded,
        this._fuseNavigationService.onNavigationItemUpdated,
        this._fuseNavigationService.onNavigationItemRemoved
      ).pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
        // Mark for check
        this._changeDetectorRef.markForCheck();
      });
    }
}
